<script setup lang="ts">
defineProps<{
  emoji: string;
}>();
</script>

<template>
  <span class="pt-0.5 font-emoji text-base/none text-lt">{{ emoji }}</span>
</template>
